import MathTool from '../math/MathTool.js'
export default class TextureTool{
    static createNoise(wWidth, wHeight){
        let ctx = document.getElementById("defaultCanvas0").getContext("2d");
        const idata = ctx.getImageData(0, 0, wWidth*2, wHeight*2);
        //const idata = ctx.createImageData(wWidth*2, wHeight*2);
        const buffer32 = new Uint32Array(idata.data.buffer);
        const len = buffer32.length;
      
        for (let i = 0; i < len; i++) {
            if (MathTool.random() < 0.5) {
                buffer32[i] = 0x90ffffff;
            }
        }
        console.log( "noise length: ", len );
        ctx.putImageData(idata, 0,0);
    }

    static generateNoise(opacity) {
        let canvas = document.getElementById("defaultCanvas0");
        let ctx = canvas.getContext("2d");
        let x, y,
        number;
        opacity = opacity || .2;
      
        for ( x = 0; x < canvas.width; x++ ) {
           for ( y = 0; y < canvas.height; y++ ) {
              number = 0;
              if (MathTool.random() < 0.5) {
                ctx.fillStyle = "rgba(0,0,0," + opacity + ")";
            }else{
                  ctx.fillStyle = "rgba(255,255,255," + opacity + ")";

              }
                ctx.fillRect(x, y, 1, 1);
           }
        }
     }

    static generateStuccoNoise(x,y,width,height, maxGrainSize, minGrainSize, numGrains){
        p5App.push();
        for (let i = 0; i < numGrains; i++) {
            let grainSize = MathTool.randInt(maxGrainSize,minGrainSize);
            
            let p = { 
                x: MathTool.randomInRange(x+width, x), 
                y: MathTool.randomInRange(y+height, y) 
            };
            let noiseColor = "#ffffff06";
            p5App.fill( noiseColor );
            p5App.rect( p.x, p.y, grainSize )
        
            noiseColor = "#00000008";
            p5App.fill( noiseColor );
            p5App.rect( p.x+grainSize, p.y+grainSize, grainSize )
          } 
          p5App.pop();
    }


    static generateScratchyoNoise(x,y,width,height, maxGrainSize, minGrainSize, numGrains){
        let ctx = window.p5App.drawingContext;
        p5App.push();
        for (let i = 0; i < numGrains; i++) {
            let grainSize = MathTool.randInt(maxGrainSize,minGrainSize);
            p5App.strokeWeight(grainSize)
            
            let p0 = { 
                x: MathTool.randomInRange(x+width, x), 
                y: MathTool.randomInRange(y+height, y) 
            };
            let p1 = { 
                x: MathTool.randomInRange(x+width, x), 
                y: MathTool.randomInRange(y+height, y) 
            };
            let noiseColor = "#ffffff";
            p5App.stroke( noiseColor );
            p5App.line( p0.x, p0.y, p1.x, p1.y )
            
            /* noiseColor = "#00000017";
            p5App.stroke( noiseColor );
            p5App.line( p0.x+grainSize, p0.y+grainSize, p1.x+grainSize, p1.y+grainSize*2 ) */
        } 
        p5App.pop();
    }
}